import { Text } from '@components/gassan-ui/Typography/Text'
import { Field } from '@gassan-ui'
import { useTranslation } from 'next-i18next'
import { FC } from 'react'
import { cn } from '@lib/cn'

type OptinOptoutFormFieldsProps = {}

export const OptinOptoutFormFields: FC<OptinOptoutFormFieldsProps> = () => {
  const { t } = useTranslation('global-items')
  const labelStyle = cn(
    'mb-4 flex w-full items-center border-b border-shade-300 pb-4',
    'first:border-t first:border-shade-300 first:pt-4',
  )

  return (
    <>
      <div className={labelStyle}>
        <Field
          mb="0"
          name="optin100"
          label={
            <div
              className={cn(
                'grid w-full items-start',
                '-mt-[0.15rem] grid-cols-1 gap-1',
                'xl:grid-cols-[250px_1fr] xl:gap-4',
              )}
            >
              <Text variant="regular" className="mb-0">
                {t('gassan_newsletter_news_title')}
              </Text>
              <Text variant="regular" className="mb-0 text-shade-500">
                {t('gassan_newsletter_news_label')}
              </Text>
            </div>
          }
          field="checkbox"
          gridColumn="span 12"
        />
      </div>
      <div className={labelStyle}>
        <Field
          mb="0"
          name="optin101"
          label={
            <div
              className={cn(
                'grid w-full items-start',
                '-mt-[0.15rem] grid-cols-1 gap-1',
                'xl:grid-cols-[250px_1fr] xl:gap-4',
              )}
            >
              <Text variant="regular" className="mb-0">
                {t('gassan_newsletter_events_title')}
              </Text>
              <Text variant="regular" className="mb-0 text-shade-500">
                {t('gassan_newsletter_events_label')}
              </Text>
            </div>
          }
          field="checkbox"
          gridColumn="span 12"
        />
      </div>
      <div className={labelStyle}>
        <Field
          mb="0"
          name="optin102"
          label={
            <div
              className={cn(
                'grid w-full items-start',
                '-mt-[0.15rem] grid-cols-1 gap-1',
                'xl:grid-cols-[250px_1fr] xl:gap-4',
              )}
            >
              <Text variant="regular" className="mb-0">
                {t('choices_newsletter_title')}
              </Text>
              <Text variant="regular" className="mb-0 text-shade-500">
                {t('choices_newsletter_label')}
              </Text>
            </div>
          }
          field="checkbox"
          gridColumn="span 12"
        />
      </div>
    </>
  )
}
